import { EstimateActions } from '../actions/actionTypes'
import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = {}

const reducer = ReducerBuilder.create(INITIAL_STATE)
  .mapAction(EstimateActions.SET_ESTIMATE, (StateType, payload) => payload)
  .build()

export default reducer
